<script lang="ts">
	export let title: string
</script>

<span class="dropdown__link__title">{title}</span>

<style lang="scss">
	@use '$styles/menubar';
</style>
